import { createFileRoute } from '@tanstack/react-router';
import { PartnersPage } from '@/features/accounting/partners-page';
import { AccountingGuard } from '@/features/accounting/guard';

export const Route = createFileRoute('/_app/accounting/partners')({ component: () => <AccountingGuard><PartnersPage /></AccountingGuard> });
